/** @format */

import { useMemo } from 'react';
import useDeviceDetect from 'src/hooks/useDeviceDetect';

export const ROW_MARGIN = 32;
export const ROW_HEIGHT_MOBILE = 92;
// Small tablets (e.g. iPad mini, 768px - 1023px) hit the `md` breakpoint (2 cols)
export const ROW_HEIGHT_TABLET = 72;
export const ROW_HEIGHT_DEFAULT = 60;

export interface GridDeviceFlags {
  isMobileOnly?: boolean;
  isSmallTablet?: boolean;
}

const getRowHeight = ({ isMobileOnly, isSmallTablet }: GridDeviceFlags): number => {
  if (isMobileOnly) return ROW_HEIGHT_MOBILE;
  if (isSmallTablet) return ROW_HEIGHT_TABLET;
  return ROW_HEIGHT_DEFAULT;
};

export const getGridConfigs = ({ isMobileOnly = false, isSmallTablet = false }: GridDeviceFlags = {}) => ({
  compactType: 'vertical' as const,
  className: 'widgetlayout',
  rowHeight: getRowHeight({ isMobileOnly, isSmallTablet }),
  breakpoints: { xxl: 1919, xl: 1439, lg: 1023, md: 767, sm: 575, xs: 0 },
  cols: { xxl: 12, xl: 12, lg: 12, md: 2, sm: 2, xs: 1 },
  margin: [ROW_MARGIN, ROW_MARGIN] as [number, number],
  containerPadding: [16, 0] as [number, number],
  isDraggable: false,
  isResizable: false,
  useCSSTransforms: false
});

const useGridConfigs = () => {
  const { isMobileOnly, isSmallTablet } = useDeviceDetect();
  return useMemo(() => getGridConfigs({ isMobileOnly, isSmallTablet }), [isMobileOnly, isSmallTablet]);
};

export default useGridConfigs;
